import React from 'react'
import styled from 'styled-components'
import { LargeWrapper } from '@raysync/common/components'
import { Devices } from '@raysync/common/theme'
import { Title, Desc } from '../atoms'
import Step1 from '@raysync/common/components/svg/solutions/p2p/step1'
import Step2 from '@raysync/common/components/svg/solutions/p2p/step2'
import Step3 from '@raysync/common/components/svg/solutions/p2p/step3'

const Section = styled.section`
  padding-top: 84px;
  padding-bottom: ${p => (typeof p.pb === 'number' ? p.pb + 'px' : '70px')};
  @media ${Devices.phone} {
    padding-top: 0.84rem;
    padding-bottom: 0.7rem;
  }
`

const List = styled.ul`
  display: flex;
  justify-content: space-between;
  margin-top: 48px;
  @media ${Devices.phone} {
    margin-top: 0.5rem;
    flex-wrap: wrap;
  }
`

const Item = styled.li`
  display: flex;
  flex-direction: column;
  width: 408px;
  svg {
    height: 60px;
    width: 60px;
    margin-bottom: 14px;
  }
  @media ${Devices.phone} {
    width: 100%;
    margin-bottom: 0.36rem;
    svg {
      width: 0.8rem;
      height: 0.8rem;
      margin-bottom: 0.16rem;
    }
  }
`

const ItemDesc = styled.p`
  line-height: 1.5;
  font-size: 16px;
  color: ${p => p.theme.color.textDarkPlus};
  @media ${Devices.phone} {
    font-size: 0.2rem;
  }
`
const List2 = styled(List)`
  flex-wrap: wrap;
`
const Item2 = styled(Item)`
  width: 650px;
  margin-bottom: 44px;
  display: block;
  img {
    height: 48px;
    max-height: 48px;
    margin-bottom: 14px;
  }
  ${ItemDesc} {
    margin-top: 10px;
    color: #636772;
  }
  @media ${Devices.phone} {
    img {
      height: 0.48rem;
      max-height: 0.48rem;
      margin-bottom: 0.16rem;
    }
    ${ItemDesc} {
      margin-top: 0.1rem;
      color: #636772;
    }
  }
`
const ItemTitle = styled.h5`
  color: ${p => p.theme.color.textDarkPlus};
  line-height: 1.4;
  font-size: 20px;
  @media ${Devices.phone} {
    font-size: 0.3rem;
  }
`

export const Challenge = ({ title, desc, items, pb }) => {
  return (
    <Section pb={pb}>
      <LargeWrapper>
        <Title>{title}</Title>
        <Desc>{desc}</Desc>
        {items && (
          <List>
            <Item>
              <Step1 />
              <ItemDesc>{items[0]}</ItemDesc>
            </Item>
            <Item>
              <Step2 />
              <ItemDesc>{items[1]}</ItemDesc>
            </Item>
            <Item>
              <Step3 />
              <ItemDesc>{items[2]}</ItemDesc>
            </Item>
          </List>
        )}
      </LargeWrapper>
    </Section>
  )
}
export const Challenge2 = ({ title, desc, items, pb }) => {
  return (
    <Section pb={pb}>
      <LargeWrapper>
        <Title>{title}</Title>
        <Desc>{desc}</Desc>
        {items && (
          <List2>
            {items.map(item => (
              <Item2>
                <img src={item.img} alt={item.title} />
                <ItemTitle>{item.title}</ItemTitle>
                <ItemDesc>{item.desc}</ItemDesc>
              </Item2>
            ))}
          </List2>
        )}
      </LargeWrapper>
    </Section>
  )
}
